// Progressive enhancement only: all links and Shopify forms work without JS.
(() => {
  const reveal = (root = document) => {
    root.querySelectorAll('[data-reveal]').forEach(el => el.classList.add('is-in'));
    root.querySelectorAll('[data-arlo-gallery-controls]').forEach(el => { el.hidden = false; });
  };
  reveal();
  document.addEventListener('shopify:section:load', event => reveal(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenus = document.querySelectorAll('.arlo-mobile-menu[open], .arlo-subnav[open]');
    if (!openMenus.length) return;
    const last = openMenus[openMenus.length - 1];
    last.open = false;
    last.querySelector('summary').focus();
  });
  document.addEventListener('click', event => {
    const arrow = event.target.closest('[data-arlo-gallery-step]');
    if (arrow) {
      const gallery = arrow.closest('[data-arlo-gallery]');
      const slides = [...gallery.querySelectorAll('[data-arlo-slide]')];
      if (slides.length > 1) {
        const current = slides.findIndex(slide => !slide.hidden);
        const next = (current + Number(arrow.dataset.arloGalleryStep) + slides.length) % slides.length;
        slides.forEach((slide, index) => { slide.hidden = index !== next; });
        gallery.querySelectorAll('[data-arlo-gallery-dot]').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === next);
        });
        gallery.querySelector('[data-arlo-image-count]').textContent = `Image ${next + 1} / ${slides.length}`;
      }
    }
    document.querySelectorAll('.arlo-mobile-menu[open], .arlo-subnav[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-arlo-product] select[name="id"]')) return;
    const product = event.target.closest('[data-arlo-product]');
    const option = event.target.selectedOptions[0];
    product.querySelector('[data-arlo-price]').textContent = option.dataset.price;
    const compare = product.querySelector('[data-arlo-compare]');
    compare.textContent = option.dataset.compare;
    compare.hidden = option.dataset.onSale !== 'true';
  });
})();
